import React from "react"
import { Col, Row } from "react-bootstrap"

const Feature = ({ icon, text }) => {
  return (
    <div className="feature-card">
      <div className="feature-card__image text-center">
        <img src={`/${icon}`} alt="" className="mx-auto" />
      </div>
      <p
        className="text-center font-weight-bold font-style-italic "
        dangerouslySetInnerHTML={{ __html: text }}
      ></p>
    </div>
  )
}

export default function FeaturesSection() {
  return (
    <Row>
      <Col md={6} lg={3}>
        <Feature icon="shirt.svg" text={"Bahan <br/> cotton combed 30s"} />
      </Col>
      <Col md={6} lg={3}>
        <Feature
          icon="pencil.svg"
          text={"Tersedia Ukuran <br /> S, M, L, XL, XXL"}
        />
      </Col>
      <Col md={6} lg={3}>
        <Feature icon="print.svg" text={"Best <br/> Printing Quality"} />
      </Col>
      <Col md={6} lg={3}>
        <Feature
          icon="frame.svg"
          text={"Varian warna <br/> Putih, Hitam, Silver"}
        />
      </Col>
    </Row>
  )
}
